/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { CifsShareService } from '../cifs-share.service';
import { CifsShareStrService } from '../cifs-share-str.service';
import { ClientCifsShareService } from '../client-cifs-share/client-cifs-share.service';
import { CopyFromCifsShareComponent } from './copy-from-cifs-share.component';

@NgModule({
    declarations: [CopyFromCifsShareComponent],
    exports: [CopyFromCifsShareComponent],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    providers: [
        CifsShareStrService,
        CifsShareService,
        ClientCifsShareService,
    ],
})
export class CopyFromCifsShareModule { }
